import { getUserEmail } from "../getUserEmail";

const BASE_KEY = "lastSelectedPluginsInSingleSearchEplex.v2";

export function getPluginsStorageKey(): string {
  const email = getUserEmail();
  return email ? `${BASE_KEY}.${email}` : BASE_KEY;
}

export function migratePluginsStorageIfNeeded(): void {
  const email = getUserEmail();
  if (!email) return;

  const oldData = localStorage.getItem(BASE_KEY);
  if (!oldData) return;

  const newKey = `${BASE_KEY}.${email}`;
  const existingData = localStorage.getItem(newKey);

  if (!existingData) {
    localStorage.setItem(newKey, oldData);
  }

  localStorage.removeItem(BASE_KEY);
}

export function getSavedPluginIds(): number[] {
  // нормализуем к number: раньше сюда могли попасть строковые id, из-за чего валидация
  // выбранных площадок промахивалась и выбор сбрасывался на «все» (CAB-586)
  const raw = JSON.parse(localStorage.getItem(getPluginsStorageKey()) ?? "[]");
  if (!Array.isArray(raw)) return [];
  return raw.map(Number).filter((id) => Number.isFinite(id));
}

export function savePluginIds(ids: number[]): void {
  localStorage.setItem(getPluginsStorageKey(), JSON.stringify(ids));
}

/**
 * Убирает из сохранённого выбора площадки, которых больше нет в каталоге (CAB-696).
 *
 * Выбор переживает смену каталога — а меняться он умеет молча: выход из демо-доступа
 * забирает демо-поставщиков, блокировка забирает своих. Пустой результат оставляем
 * пустым: `filterValidPluginIds` на пустом сохранённом выборе отмечает весь доступный
 * каталог, и это ровно то, что нужно новой вкладке.
 */
export function pruneSavedPluginIds(availableIds: number[]): void {
  const available = new Set(availableIds.map(Number));
  const saved = getSavedPluginIds();
  const kept = saved.filter((id) => available.has(id));

  if (kept.length !== saved.length) savePluginIds(kept);
}
